// @ts-check
import PlayerOutcomeModel from './player-outcome.model';

export default class PlayerMarketModel {
  /**
   * @param {import('./player.api').TMarket} data - market
   * @param {import('./player.api').TPlayerMap} [playerMap] - player map
   */
  constructor(data, playerMap) {
    /**
     * Market name
     * @type {string}
     */
    this.marketName = data.n;
    /**
     * Market id
     * @type {number}
     */
    this.marketId = data.id;
    /**
     * If this odd is combination with other odds
     * Single = 1, can be played only single
     * Unique = 2, can be played as a single at least
     * Trebles = 3, can be played in a combination with at least three other
     * Quadruple = 4, can be played in a combination with at least four other
     * Quintuple = 5 can be played in a combination with at least five
     * @type {number}
     */
    this.isCombo = data.c;
    if (data.ca) {
      /**
       * Flag if cashout is available for this market
       * @type {boolean}
       */
      this.cashoutAvailable = data.ca;

      this.cashout = data.ca;
    }
    /**
     * Flag if market has outcomes with SBV
     * @type {boolean}
     */
    this.hasSbv = false;
    const rawOutcomes = data.m || [];
    /**
     * Market outcomes list
     * @type {PlayerOutcomeModel[]}
     */
    this.outcomes = rawOutcomes.map(o => new PlayerOutcomeModel(o, playerMap));
    this.outcomes.sort((a, b) => (+a.outcome) - (+b.outcome));
    /**
     * Market outcome layout
     * @type {string | undefined}
     */
    this.outcomeLayout;
    /**
     * Flag to indicate if market is live or prematch
     * @type {boolean}
     */
    this.isLive = false;
  }
}